import React, { useMemo, useCallback } from "react";
// import { Flex, Button, Message } from "@digitallabs/one-x-ui";
import { Flex, Button, Message } from "../../../resourses/digitallabs/one-x-ui";
import { CheckIcon, XIcon } from "@phosphor-icons/react";
import { MAIN_STEPS } from "../../../constants/constants";

const DynamicChips = ({
  field,
  fieldRefs,
  value,
  isMain,
  step,
  submitted,
  errors,
  updateValue,
  renderLabelWithPrefix,
  renderField,
  resetSubtree,
  safeState,
}) => {
  const fieldName = field.name;

  /* ---------------- SHOW SUB LOGIC ---------------- */
  const visibleSubQuestions = useMemo(() => {
    if (!field.sub_questions) return [];

    return field.sub_questions.filter((sub) => {
      /*
        answer_selected meaning:
  
        null  -> always show
        value -> show only when selected chip matches
      */

      if (sub.answer_selected === null || sub.answer_selected === undefined || sub.answer_selected === "") {
        return true;
      }

      return sub.answer_selected === value;
    });
  }, [field.sub_questions, value]);

  /* ---------------- STABLE REF ---------------- */
  const setFieldRef = useCallback(
    (el) => {
      if (el) {
        fieldRefs.current[fieldName] = el;
      }
    },
    [fieldRefs, fieldName]
  );

  return (
    <Flex direction="column" gap="xs" className="dfh-field-wrapper" ref={setFieldRef}>
      {/* Label */}
      <span className={isMain ? (step === MAIN_STEPS.PERSONAL_DETAILS ? "dfh-label-small" : "dfh-label") : "subquestion-label"}>
        {renderLabelWithPrefix(isMain, field.question, step)}
      </span>

      {/* Error */}
      {submitted && errors[fieldName] && (
        <Flex align="center" gap="xs">
          <Message
            message={{
              primary: errors[fieldName],
            }}
            style={{
              width: "100%",
              marginBottom: "10px",
            }}
            onClose={() => {}}
            variant="error"
          />
        </Flex>
      )}

      {/* Chips */}
      <div
        style={{
          display: "flex",
          gap: "12px",
          overflowX: "auto",
          whiteSpace: "nowrap",
          marginLeft: step === MAIN_STEPS.PERSONAL_DETAILS ? "-4px" : isMain ? "12px" : "0px",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        className="hide-scrollbar"
      >
        {field.valid_answers?.map((ans) => {
          const option =
            typeof ans === "object"
              ? ans
              : {
                  value: ans,
                  label: ans,
                };

          const selected = value === option.value;

          const disableOption =
            fieldName === "residentialStatus" && safeState?.["nationality"] === "Non-Indian/OCI/PIO" && option.value === "Resident Indian";

          return (
            <Button
              key={option.value}
              disabled={disableOption}
              size={step === MAIN_STEPS.PERSONAL_DETAILS ? "md" : "sm"}
              startIcon={option.value === "Yes" ? <CheckIcon /> : option.value === "No" ? <XIcon /> : null}
              color={selected ? "primary" : "gray"}
              variant="secondary"
              style={{
                margin: "4px",
                borderRadius: "40px",
                flexShrink: 0,
              }}
              onClick={() => {
                if (value === option.value) return;

                updateValue(fieldName, option.value);

                if (field.sub_questions) {
                  resetSubtree(field.sub_questions);
                }
              }}
            >
              {option.label}
            </Button>
          );
        })}
      </div>

      {/* Sub Questions */}
      {visibleSubQuestions.map((sub, i) => (
        <Flex
          key={sub.name ?? `${fieldName}-sub-${i}`}
          direction="column"
          style={{
            marginTop: "12px",
            marginLeft: isMain ? "12px" : "0px",
          }}
        >
          {renderField(sub)}
        </Flex>
      ))}
    </Flex>
  );
};

export default React.memo(DynamicChips);
